<app-disco-form [autoSave]=true formKey="attachments" [isEditMode]="true" [data]="data"
    (onSubmit)="onSubmit($event)"></app-disco-form>